import { render, staticRenderFns } from "./SearchCharityResultTileWidget.vue?vue&type=template&id=52ea8c45&scoped=true&"
import script from "./SearchCharityResultTileWidget.vue?vue&type=script&lang=js&"
export * from "./SearchCharityResultTileWidget.vue?vue&type=script&lang=js&"
import style0 from "./SearchCharityResultTileWidget.vue?vue&type=style&index=0&id=52ea8c45&scoped=true&lang=css&"
import style1 from "./SearchCharityResultTileWidget.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ea8c45",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VHover,VIcon,VImg,VRow})
